import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { format, addWeeks, startOfWeek, endOfWeek } from "date-fns";
import { es } from "date-fns/locale";
import { motion, AnimatePresence } from "framer-motion";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Footer from "components/footers/FourColumnWithInputForm.js";
import Header from "./../components/headers/HeaderLight"
import { css } from "styled-components/macro"; //eslint-disable-line
import tw from "twin.macro";
import styled from "styled-components";
import GymllustrationSrc from "images/demo/gym.png";
import TerracellustrationSrc from "images/demo/terrace.png";
import GrillllustrationSrc from "images/demo/grill.png";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { SectionHeading } from "components/misc/Headings.js";
import SwimmingPoolllustrationSrc from "images/demo/swimming-pool.png";
import { Container } from "components/misc/Layouts";
import DownloadApp from "components/cta/DownloadApp.js";
import IllustrationSrc from "images/demo/booking-online.png";
import { ReactComponent as SvgDotPattern } from "images/dot-pattern.svg"
import { Button } from "reactstrap";
import { ROUTE_PATHS } from "utils/routes.js";


const HeaderContainer = tw.div`relative`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24 items-center`;
const ImageColumn = tw(Column)`md:w-6/12 flex-shrink-0 relative`;
const TextContent = tw.div`lg:py-8 text-center md:text-left`;
const Heading = tw(
    SectionHeading
)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;
const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
const CardButton = tw(PrimaryButtonBase)`w-full rounded-b-lg rounded-t-none py-3 font-semibold flex items-center justify-center`;
const PreviewCards = tw.div`grid grid-cols-3 gap-x-8 gap-y-16`;
const PreviewCardContainer = tw.div`mt-0 mx-auto max-w-lg w-full`;
const PreviewCard = tw(motion.a)`block rounded-lg border border-gray-200`;

const TextColumn = styled(Column)(props => [
    tw`md:w-6/12 mt-16 md:mt-0`,
    props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);
const Image = styled.img(props => [
    props.imageRounded && tw`rounded`,
    props.imageBorder && tw`border`,
    props.imageShadow && tw`shadow`,
]);
const DecoratorBlob = styled(SvgDotPattern)(props => [
    tw`w-20 h-20 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current text-primary-500 -z-10`,
]);

const RightShadow = styled.div`
        box-shadow: 16px 0 32px -4px rgba(0,0,0,0.18), 8px 0 16px -8px rgba(0,0,0,0.12);
        border-radius: 0.5rem;
`;
const BodyContainer = tw.div`rounded-t-lg border-0 border-b-0`;
const PreviewCardImage = styled(motion.div)`
    ${props => css`background-image: url("${props.$imageSrc}");`}
    ${tw`h-24 md:h-32 bg-white rounded-t-lg flex items-center justify-center`}
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-position: center;
    overflow: hidden;
`;

const ButtonTw = tw(
    Button
)`px-8 py-3 font-bold rounded bg-primary-500 text-gray-100 hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline focus:outline-none transition duration-300 mt-12 inline-block tracking-wide text-center px-10 py-4 font-semibold tracking-normal`;


const previewImageAnimationVariants = {
    rest: {
        backgroundPositionY: "0%"
    },
    hover: {
        backgroundPositionY: "100%",
        transition: { type: "tween", ease: "linear", duration: 5 }
    }
};

const amenities = [
    {
        name: "Alberca",
        imageSrc: SwimmingPoolllustrationSrc,
        daysOfWeek: [{ name: "Continuar", day: "Mar." }, { name: "Continuar", day: "Miér." }, { name: "Continuar", day: "Jue." }, { name: "Continuar", day: "Vie." }, { name: "Continuar", day: "Sáb." }, { name: "Continuar", day: "Dom." }],
        isTimeSlotRequired: true,
        timeSlotList : [
            {
                name: "10:00~AM",
                totalOfTimeSlots: 3,
                slotStatuses: [{count:1, status:"aprob."}, {count:1, status:"pte."}, {count:1, status:"disp."}]
                
            },
            {
                name: "12:00~PM",
                totalOfTimeSlots: 3,
                slotStatuses: [{count:1, status:"aprob."}, {count:1, status:"pte."}, {count:1, status:"disp."}]
            },
            {
                name: "2:00~PM",
                totalOfTimeSlots: 3,
                slotStatuses: [{count:1, status:"aprob."}, {count:1, status:"pte."}, {count:1, status:"disp."}]
            },
            {
                name: "4:00~PM",
                totalOfTimeSlots: 3,
                slotStatuses: [{count:1, status:"aprob."}, {count:1, status:"pte."}, {count:1, status:"disp."}]
            },
            {
                name: "6:00~PM",
                totalOfTimeSlots: 3,
                slotStatuses: [{count:1, status:"aprob."}, {count:1, status:"pte."}, {count:1, status:"disp."}]
            },
            {
                name: "6:00~PM",
                totalOfTimeSlots: 3,
                slotStatuses: [{count:1, status:"aprob."}, {count:1, status:"pte."}, {count:1, status:"disp."}]
            },
            {
                name: "8:00~PM",
                totalOfTimeSlots: 3,
                slotStatuses: [{count:1, status:"aprob."}, {count:1, status:"pte."}, {count:1, status:"disp."}]
            }
        ],
        isPaidRequired: false,
        paymentAmount: 0
    },
    {
        name: "Terraza",
        imageSrc: TerracellustrationSrc,
        daysOfWeek: [{ name: "Continuar", day: "Lun." }, { name: "Continuar", day: "Mar." }, { name: "Continuar", day: "Miér." }, { name: "Continuar", day: "Jue." }, { name: "Continuar", day: "Vie." }, { name: "Continuar", day: "Sáb." }, { name: "Continuar", day: "Dom." }],
        isTimeSlotRequired: false,
        isPaidRequired: true,
        paymentAmount: 500
    },
    {
        name: "Asadores",
        imageSrc: GrillllustrationSrc,
        daysOfWeek: [{ name: "Continuar", day: "Lun." }, { name: "Continuar", day: "Mar." }, { name: "Continuar", day: "Miér." }, { name: "Continuar", day: "Jue." }, { name: "Continuar", day: "Vie." }, { name: "Continuar", day: "Sáb." }, { name: "Continuar", day: "Dom." }],
        isTimeSlotRequired: false,
        isPaidRequired: true,
        paymentAmount: 250
    },
    {
        name: "Gimnasio",
        imageSrc: GymllustrationSrc,
        daysOfWeek: [{ name: "Continuar", day: "Lun." }, { name: "Continuar", day: "Mar." }, { name: "Continuar", day: "Miér." }, { name: "Continuar", day: "Jue." }, { name: "Continuar", day: "Vie." }, { name: "Continuar", day: "Sáb." }],
        isTimeSlotRequired: true,
        timeSlotList : [
            {
                name: "6:00~AM",
                totalOfTimeSlots: 10,
                slotStatuses: [{count:5, status:"aprob."}, {count:2, status:"pte."}, {count:3, status:"disp."}]
            },
            {
                name: "7:30~AM",
                totalOfTimeSlots: 10,
                slotStatuses: [{count:1, status:"aprob."}, {count:4, status:"disp."}, {count:5, status:"pte."}]
            },
            {
                name: "9:00~AM",
                totalOfTimeSlots: 10,
                slotStatuses: [{count:0, status:"aprob."},{count:10, status:"disp."}, {count:0, status:"pte."}]
            },
            {
                name: "10:30~AM",
                totalOfTimeSlots: 10,
                slotStatuses: [{count:5, status:"aprob."}, {count:5, status:"pte."}, {count:0, status:"disp."}]
            },
            {
                name: "12:00~PM",
                totalOfTimeSlots: 10,
                slotStatuses: [{count:2, status:"pte."}, {count:3, status:"disp."}, {count:5, status:"pte."}]
            },
            {
                name: "1:30~PM",
                totalOfTimeSlots: 10,
                slotStatuses: [{count:5, status:"pte."}, {count:5, status:"pte."}, {count:0, status:"pte."}]
            },
            {
                name: "3:00~PM",
                totalOfTimeSlots: 10,
                slotStatuses: [{count:1, status:"aprob."}, {count:2, status:"pte."}, {count:7, status:"disp."}]
            },
            {
                name: "4:30~PM",
                totalOfTimeSlots: 10,
                slotStatuses: [{count:5, status:"aprob."}, {count:5, status:"pte."}, {count:0, status:"disp."}]
            },
            {
                name: "6:00~PM",
                totalOfTimeSlots: 10,
                slotStatuses: [{count:5, status:"aprob."}, {count:0, status:"disp."}, {count:5, status:"pte."}]
            },
            {
                name: "7:30~PM",
                totalOfTimeSlots: 10,
                slotStatuses: [{count:0, status:"aprob."}, {count:0, status:"disp."}, {count:10, status:"pte."}]
            },
            {
                name: "9:00~PM",
                totalOfTimeSlots: 10,
                slotStatuses: [{count:5, status:"aprob."}, {count:5, status:"pte."}, {count:0, status:"disp."}]
            }
        ],
        isPaidRequired: false,
        paymentAmount: 0
    }
]

const daysOfWeek = [{ name: "Continuar", day: "Lun." }, { name: "Continuar", day: "Mar." }, { name: "Continuar", day: "Miér." }, { name: "Continuar", day: "Jue." }, { name: "Continuar", day: "Vie." }, { name: "Continuar", day: "Sáb." }, { name: "Continuar", day: "Dom." }];


export default function AmenitySelectionPage() {
    const navigate = useNavigate();

    const [cards, setCards] = useState(amenities);
    const [stepNumber, setStepNumber] = useState(1);
    const [currentWeek, setCurrentWeek] = useState(0); // 0 = current week
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [amenity, setAmenity] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [timeSlot, setTimeSlot] = useState("");

    const today = new Date();
    const maxWeeks = 5;
    const weekStart = addWeeks(startOfWeek(today, { weekStartsOn: 1 }), currentWeek);
    const weekEnd = endOfWeek(weekStart, { weekStartsOn: 1 });
    const weekText = `${format(weekStart, "MMM d, yyyy", { locale: es })} - ${format(weekEnd, "MMM d, yyyy", { locale: es })}`;

    const handlePrevWeek = () => {
        if (currentWeek > 0) {
            setCurrentWeek(currentWeek - 1);
        }
    };
    const handleNextWeek = () => {
        if (currentWeek < maxWeeks) {
            setCurrentWeek(currentWeek + 1);
        }
    };

    const handleCardClick = (card, index) => {
        if (cards.find(c => c.name === card.name) && stepNumber === 1) {
            setStepNumber(2);
            setCards(card.daysOfWeek);
            setAmenity(card);
        }
        if (cards.find(c => c.name === card.name) && stepNumber === 2) {
            // Calculate the actual selected date
            const actualSelectedDate = addWeeks(startOfWeek(today, { weekStartsOn: 1 }), currentWeek);
            actualSelectedDate.setDate(actualSelectedDate.getDate() + index);
            setSelectedDate(actualSelectedDate);
            //setSelectedDayIndex(index); // Store which day was selected
            // Related to the workflow
            if (amenity?.isTimeSlotRequired) {
                setStepNumber(3);
                setCards(amenity.timeSlotList);
            }
            else {
                setShowModal(true);
            }
        }
        if (cards.find(c => c.name === card.name) && stepNumber === 3) {
            setShowModal(true);
            setTimeSlot(card.name);
        }
    };

    const handleAgendarClick = () => {
        setShowModal(false);
        navigate(ROUTE_PATHS.AMENITIES)
    };

    const generateReferenceNumber = () => {
        let referenceNumber = "";
        referenceNumber = Math.floor(100000 + Math.random() * 900000).toString();
        return referenceNumber;
    };

    return (
        <AnimationRevealPage>
            <Header />
            <HeaderContainer>
                <TwoColumn>
                    <ImageColumn>
                        <Image src={IllustrationSrc} imageBorder={false} imageShadow={false} imageRounded={true} />
                        <DecoratorBlob />
                    </ImageColumn>
                    <TextColumn textOnLeft={true}>
                        <TextContent>
                            <Heading>{<> Reservación de <span className="text-primary-500">Amenidades</span></>}</Heading>
                            <Description>{"Sigue cuidadosamente las instrucciones y selecciona la fecha y horario deseado segun aplique al tipo de amenidad."}</Description>
                        </TextContent>
                    </TextColumn>
                </TwoColumn>
            </HeaderContainer>

            <Container tw="pt-8 px-8 mt-12 mb-12" >

                {/** Go Back Navigation **/}
                <div className="items-center justify-center mb-4">
                    <button
                        className="px-4 py-2 rounded-full bg-blue-200 text-black mr-4 hover:bg-gray-400 flex items-center"
                        onClick={() => navigate(ROUTE_PATHS.AMENITIES)}
                    >
                        <span style={{ fontSize: "1.25rem", lineHeight: '1.75rem', display: 'flex', alignItems: 'center' }}>&#8592;</span>
                        <span className="font-semibold text-base mx-2 text-left flex items-center">Atrás</span>
                    </button>
                </div>

                {/** Week Navigation **/}
                {stepNumber === 2 && (
                    <div className="flex items-center justify-center mb-8">
                        <button
                            className={`px-4 py-2 rounded-full bg-gray-200 text-black mr-4 ${currentWeek === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-400'}`}
                            onClick={handlePrevWeek}
                            disabled={currentWeek === 0}
                        >
                            <span style={{ fontSize: "2rem", lineHeight: 1 }}>&#8592;</span>
                        </button>
                        <span className="font-semibold text-3xs mx-4 text-center">{weekText}</span>
                        <button
                            className={`px-4 py-2 rounded-full bg-gray-200 text-black ml-4 ${currentWeek === maxWeeks ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-400'}`}
                            onClick={handleNextWeek}
                            disabled={currentWeek === maxWeeks}
                        >
                            <span style={{ fontSize: "2rem", lineHeight: 1 }}>&#8594;</span>
                        </button>
                    </div>
                )}

                {/** Cards Section **/}
                <AnimatePresence mode="wait">
                    <motion.div
                        key={stepNumber}
                        initial={{ scale: 0.8, opacity: 0, transformOrigin: '50% 50%' }}
                        animate={{ scale: 1, opacity: 1, transformOrigin: '50% 50%' }}
                        exit={{ scale: 0.8, opacity: 0, transformOrigin: '50% 50%' }}
                        transition={{ duration: 0.5, ease: "easeInOut" }}
                        style={{ transformOrigin: '50% 50%' }}
                    >
                        <PreviewCards>
                            {cards.map((card, index) => (
                                <PreviewCardContainer key={`${card.name}-${index}`}>
                                    <RightShadow>
                                        <PreviewCard initial="rest" animate="rest" whileHover="hover">
                                            { (stepNumber === 1) && (
                                                <BodyContainer>
                                                    <PreviewCardImage
                                                        transition={{ type: "tween" }}
                                                        variants={previewImageAnimationVariants}
                                                        $imageSrc={card.imageSrc}
                                                    />
                                                </BodyContainer>
                                            ) }
                                            { (stepNumber === 2) && (
                                                <BodyContainer>
                                                    <div className="flex flex-wrap items-center justify-center h-full w-full py-2 text-lg font-semibold text-blue-800">
                                                        <span className="min-w-[70px] max-w-[100px] text-center break-words">{card.day}</span>
                                                        <span className="min-w-[70px] max-w-[100px] text-center break-words">
                                                            {format(addWeeks(startOfWeek(today, { weekStartsOn: 1 }), currentWeek).setDate(addWeeks(startOfWeek(today, { weekStartsOn: 1 }), currentWeek).getDate() + index), "MMM d, yyyy", { locale: es })}
                                                        </span>
                                                    </div>
                                                </BodyContainer>
                                            )}
                                            { (stepNumber === 3) && (
                                                <BodyContainer>
                                                    <div className="flex flex-wrap gap-2 items-center justify-center h-full w-full py-2">
                                                        {card.slotStatuses.map((slot, index) => {
                                                            let statusClass = "bg-blue-500";
                                                            if (slot.status === "pte.") {
                                                                statusClass = "bg-yellow-500";
                                                            } else if (slot.status === "aprob.") {
                                                                statusClass = "bg-green-600";
                                                            }
                                                            return (
                                                                <div key={`${slot.status}-${index}`} className={`min-w-[60px] max-w-[80px] h-8 rounded-lg flex items-center justify-center text-white font-semibold text-xs ${statusClass}`}
                                                                    style={{flex: '1 1 30%', margin: '2px'}}>
                                                                    {slot.count} {slot.status}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </BodyContainer>
                                            )}

                                            {/** Card Button logic */}
                                            {stepNumber === 2 && (
                                                (() => {
                                                    const cardDate = (() => {
                                                        const baseDate = addWeeks(startOfWeek(today, { weekStartsOn: 1 }), currentWeek);
                                                        baseDate.setDate(baseDate.getDate() + index);
                                                        return baseDate;
                                                    })();
                                                    const isPast = cardDate < new Date(today.setHours(0,0,0,0));
                                                    return (
                                                        <CardButton
                                                            onClick={() => handleCardClick(card, index)}
                                                            disabled={isPast}
                                                            style={isPast ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                                        >
                                                            {card.name}
                                                        </CardButton>
                                                    );
                                                })()
                                            )}
                                            {stepNumber === 3 && (() => {
                                                // Parse hour from card.name (e.g., "10:00~AM")
                                                const hourRegex = /(\d{1,2}):(\d{2})~(AM|PM)/;
                                                const hourMatch = hourRegex.exec(card.name);
                                                let isPast = false;
                                                if (hourMatch) {
                                                    let hour = parseInt(hourMatch[1], 10);
                                                    let minute = parseInt(hourMatch[2], 10);
                                                    let period = hourMatch[3];
                                                    if (period === "PM" && hour !== 12) hour += 12;
                                                    if (period === "AM" && hour === 12) hour = 0;
                                                    
                                                    // Use the selectedDate which was set when day was chosen
                                                    const slotDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), hour, minute, 0, 0);
                                                    const now = new Date();
                                                    const isSameDay = slotDate.getFullYear() === now.getFullYear() && slotDate.getMonth() === now.getMonth() && slotDate.getDate() === now.getDate();
                                                    
                                                    // Only disable if today and time has passed
                                                    isPast = isSameDay && slotDate.getTime() <= now.getTime();
                                                }
                                                return (
                                                    <CardButton
                                                        onClick={() => handleCardClick(card, index)}
                                                        disabled={isPast}
                                                        style={isPast ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                                    >
                                                        {card.name}
                                                    </CardButton>
                                                );
                                            })()}
                                            {stepNumber === 1 && (
                                                <CardButton onClick={() => handleCardClick(card, index)}>{card.name}</CardButton>
                                            )}
                                        </PreviewCard>
                                    </RightShadow>
                                </PreviewCardContainer>
                            ))}
                        </PreviewCards>
                    </motion.div>
                </AnimatePresence>

                {/** Show Modal Confirmation**/}
                {showModal && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center" style={{ background: 'rgba(108,117,125,0.65)' }}>
                        <div className="bg-white rounded-lg shadow-lg p-8 max-w-sm w-full relative">
                            <h1 className="text-xl font-bold text-center text-primary-700 mb-4">Confirmación</h1>
                            <p className="text-center text-gray-700 mb-2">Fecha de la reservación:</p>
                            <p className="text-center font-bold text-primary-500 mb-2">{format(selectedDate, "d MMMM yyyy", { locale: es })}</p>
                            {amenity?.isTimeSlotRequired && <p className="text-center font-bold text-primary-500 mb-2">{timeSlot}</p>}
                            {amenity?.isPaidRequired && <div className="text-center text-3xl font-mono font-bold text-blue-600 mb-6">{`$${amenity?.paymentAmount}.00 MXN`}</div>}
                            {amenity?.isPaidRequired &&<p className="text-center text-gray-700 mb-2">Tu referencia numérica para transferencia:</p>}
                            {amenity?.isPaidRequired && <div className="text-center text-3xl font-mono font-bold text-blue-600 mb-6">{generateReferenceNumber()}</div>}
                            <ButtonTw
                                color="primary"
                                className="w-full"
                                onClick={() => handleAgendarClick()}
                            >
                                Agendar
                            </ButtonTw>
                        </div>
                    </div>
                )}
            </Container>      
            <div className="pt-12">
                <DownloadApp
                    text={<>Próximamente espera por nuesta versión <HighlightedTextInverse>Movil.</HighlightedTextInverse></>}
                />
                <Footer />
            </div>
        </AnimationRevealPage>
    );
}
